import { Container, i18n, utils, Table, TableRow, Monthpicker, DefaultFormat } from "@common";
import { useRef, useCallback, useState, useEffect } from 'react';
import "./index.less";
import { adminService } from "@api";

const ApplicationUsage = () => {
    const tableRef = useRef();
    const [month, setMonth] = useState(new Date());
    const [cisData, setCisData] = useState();

    const columns = [
        { header: i18n.get('CIS_Admin_Reporting_ApplicationUsage_ApplicationName_Entry'), sortable: true, valuePath: 'ApplicationName' },
        { header: i18n.get('CIS_Admin_Reporting_ApplicationUsage_SuccessfulSignIns_Entry'), sortable: true, valuePath: 'SuccessfulSignIns' },
        { header: i18n.get('CIS_Admin_Reporting_ApplicationUsage_FailedSignIns_Entry'), sortable: true, valuePath: 'FailedSignIns' },
        { header: i18n.get('CIS_Admin_Reporting_ApplicationUsage_UniqueUsers_Entry') },
    ];

    const handleDateChanged = (monthValue) => {
        setMonth(monthValue.newValue);
        tableRef.current.handleFilter({ period: [utils.formatDateTime(monthValue.newValue, DefaultFormat.Month)] });
    };

    const download = useCallback(() => {
        $$.loading(true);
        const exportInfo = tableRef.current.getExportInfo();
        exportInfo.filters["period"] = [utils.formatDateTime(month, DefaultFormat.Month)];
        exportInfo.pageIndex = 0;
        exportInfo.pageSize = 0;
        exportInfo['timeZone'] = new Date().getTimezoneOffset() / -60;
        adminService.applicationUsageFindCisAllDownload(exportInfo).then(() => {
            $$.loading(false);
            return true;
        });
    }, [month]);

    useEffect(() => {
        $$.loading(true);
        const exportInfo = tableRef.current.getExportInfo();
        exportInfo.filters["period"] = [utils.formatDateTime(month, DefaultFormat.Month)];
        exportInfo.pageIndex = 0;
        exportInfo.pageSize = 0;
        adminService.applicationUsageFindCisAll(exportInfo).then((res) => {
            setCisData(res?.items);
            $$.loading(false);
        });
    }, [month]);

    const onLoadData = useCallback((info) => {
        return adminService.applicationUsageAll(info);
    }, []);

    return (
        <Container>
            <div className="margin-bottom-s">
                <Monthpicker
                    id="ApplicationUsage-Period"
                    selectedDate={month}
                    onChange={handleDateChanged}
                    dateTimeFormat={DefaultFormat.Month}
                    height={'28px'}
                />
            </div>
            <R.Button className="margin-top-m" classify="info" text={i18n.get('CIS_Admin_Common_Download_Entry')} onClick={download} />
            <div className="cisBox">
                <div className="cisTitle">{i18n.get('CIS_Admin_Common_CIS_Title_Entry')}</div>
                <div className="cisContent">
                <div className="contentBox">
                        <div className="number">{utils.formatDateTime(month, DefaultFormat.Month)}</div>
                        <div className="caption">{i18n.get('CIS_Admin_Reporting_ApplicationUsage_Period_Entry')}</div>
                    </div>
                    <div className="contentBox">
                        <div className="number">{cisData?.successfulSignIns}</div>
                        <div className="caption">{i18n.get('CIS_Admin_Reporting_ApplicationUsage_SuccessfulSignIns_Entry')}</div>
                    </div>
                    <div className="contentBox">
                        <div className="number">{cisData?.failedSignIns}</div>
                        <div className="caption">{i18n.get('CIS_Admin_Reporting_ApplicationUsage_FailedSignIns_Entry')}</div>
                    </div>
                    <div className="contentBox">
                        <div className="number">{cisData?.uniqueUsers}</div>
                        <div className="caption">{i18n.get('CIS_Admin_Reporting_ApplicationUsage_UniqueUsers_Entry')}</div>
                    </div>
                </div>
            </div>
            <Table
                id="table-applicanton-usage"
                ref={tableRef}
                onLoadData={onLoadData}
                rowTemplate={TableRowTemp}
                columns={columns}
                filter={{ params: { period: [utils.formatDateTime(month, DefaultFormat.Month)] } }}
            />
        </Container>
    );
};

class TableRowTemp extends TableRow {
    render(Row, Cell) {
        const { applicationName, successfulSignIns, failedSignIns, uniqueUsers } = this.props.rowData;
        return (
            <Row action={this.action}>
                <Cell>{applicationName || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{successfulSignIns || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{failedSignIns || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{uniqueUsers || i18n.get('Common_NA_Entry')}</Cell>
            </ Row>
        );
    }
}

export default ApplicationUsage;

